import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Pagination, Box } from '@mui/material';
import { useList } from './ListContext';
export var PaginationComponent = function () {
    var _a = useList(), currentPage = _a.currentPage, setPage = _a.setPage, totalPages = _a.totalPages;
    var handleChange = function (event, value) {
        setPage(value);
    };
    if (!totalPages) {
        return null;
    }
    return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', padding: '1rem' }, children: _jsx(Pagination, { count: totalPages, page: currentPage, onChange: handleChange, color: "primary", shape: "rounded" }) }));
};
